import { render, staticRenderFns } from "./RightEvaluationDetails.vue?vue&type=template&id=0f97bc4a&"
import script from "./RightEvaluationDetails.vue?vue&type=script&lang=js&"
export * from "./RightEvaluationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports